import lsg_slidecart_rebuild from './sections/lsg-slidecart-rebuild';

import './components/lsg-cart-handler';
import './components/lsg-mini-upsell-carousel';
import nss_marquee from './sections/nss-marquee';
import nss_quick_add_modal from './sections/nss-quick-add-modal';
import nss_scrolling_5050 from './sections/nss-scrolling-5050';
import nss_oil_change_modal from './sections/nss-oil-change-modal';
import nss_video from './components/nss-video';
import nss_review_carousel from './sections/nss-review-carousel';

(function() {

    lsg_slidecart_rebuild.init();
    nss_marquee.init();
    nss_quick_add_modal.init();
    nss_scrolling_5050.init();
    nss_oil_change_modal.init();
    nss_video.init();
    nss_review_carousel.init();

})();